import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { isTrue, isEmptyString } from '@utils/object-utils';
import { Ink } from './ink';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class BaseTypographyComponent {
  @Input() bold?: boolean;
  @Input() semiBold?: boolean;
  @Input() italic?: boolean;
  /** Default matches typography SCSS (`var(--ink-85)`); remaps to light text in dark mode. */
  @Input() ink: Ink = 'ink-85';
  @Input() noMargin?: boolean;

  get ngClass(): string[] {
    return [
      this.checkBoolInput(this.bold) ? 'bold' : '',
      this.checkBoolInput(this.semiBold) ? 'semi-bold' : '',
      this.checkBoolInput(this.italic) ? 'italic' : '',
      this.checkBoolInput(this.noMargin) ? 'no-margin' : '',
      this.ink ?? 'ink-85'
    ].filter((c): c is string => c != null && c !== '');
  }

  private checkBoolInput(value: any): boolean {
    return isTrue(value) || isEmptyString(value);
  }
}
